/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import ApplicationState     from 'store/application'
  import GUI                  from 'services/gui';
  import Projections          from 'store/projections';
  import InputText            from "components/InputText.vue";
  import { getUniqueDomId }   from 'utils/getUniqueDomId';
  import { gettext as _ }     from 'g3w-i18n';

    const __vue_script__ = {

    /** @since 3.8.6 */
    name: 'spatial-bookmarks',

    components: {
      InputText,
    },

    data() {
      const gid             = ApplicationState.project.getId();
      const SAVED_BOOKMARKS = JSON.parse(window.localStorage.getItem('SPATIALBOOKMARKS') || '{}');
      SAVED_BOOKMARKS[gid]  = SAVED_BOOKMARKS[gid] || [];
      window.localStorage.setItem('SPATIALBOOKMARKS', JSON.stringify(SAVED_BOOKMARKS || '{}'));

      return {

        /**
         * true = show add dialog menu
         */
        showaddform: false,

        /**
         * spatial bookmarks saved on current QGIS project
         * 
         * bookmark is an array of Object with follow structure:
         * {
         *   name: <String> Unique identifier of spatial bootmark,
         *   removable: <Boolean> true if set in QGIS project, false if add by user on G3W-SUITE application,
         *   extent: <Array> Contain the map bbox coordinates
         * }
         */

        project: {
          bookmarks: ApplicationState.project.state.bookmarks || []
        },

        user: {
          bookmarks: SAVED_BOOKMARKS[gid]
        },

        addbookmarkinput: {
          name:     'add-bookmark',
          label:    _('Name'),
          i18nLabel:true,
          value:    null,
          editable: true,
          type:     'varchar',
          input:    { type: 'text', options: {} },
          visible:  true,
          validate: { valid:    false, required: true }
        }
      }
    },

    computed: {

      /** @since 3.10.0 */
      is_staff() {
        return window.initConfig.user.is_staff;
      },

      /** @since 3.10.0  */
      lang() {
        return ApplicationState.language;
      },

      /** @since 4.0.0 */
      is_mobile() {
        return window.innerWidth < 767;
      }

    },

    methods: {

      addBookMark() {
        this.user.bookmarks.push({
          id:        getUniqueDomId(),
          name:      this.addbookmarkinput.value,
          extent:    GUI.getService('map').getMapExtent(),
          removable: true,
          crs:       { epsg: 1*GUI.getService('map').getCrs().split('EPSG:')[1] }
        });

        this.saveUserBookMarks();
        this.showaddform = false;
      },

      removeBookMark(id) {
        this.user.bookmarks = this.user.bookmarks.filter(b => id !== b.id);
        this.saveUserBookMarks();
      },

      saveUserBookMarks() {
        const gid             = ApplicationState.project.getId();
        const SAVED_BOOKMARKS = JSON.parse(window.localStorage.getItem('SPATIALBOOKMARKS') || '{}');
        SAVED_BOOKMARKS[gid]  = this.user.bookmarks || [];
        window.localStorage.setItem('SPATIALBOOKMARKS', JSON.stringify(SAVED_BOOKMARKS || '{}'));
      },

      showAddForm() {
        this.addbookmarkinput.value = null;
        this.showaddform            = true;
      },

      async gotoSpatialBookmark({ extent, crs }) {
        // automatically hide sidebar on mobile
        if (window.innerWidth < 767) {
          GUI.hideSidebar();
        }
        if (crs.epsg !== GUI.getService('map').getEpsg().split('EPSG:')[1]) {
          const projection = await Projections.registerProjection(`EPSG:${crs.epsg}`);
          extent = ol.proj.transformExtent(extent, projection, GUI.getService('map').getProjection())
        }
        // make use of `force: true` parameter to get resolution from computed `extent`
        GUI.getService('map').zoomToExtent(extent, { force: true });
      },

    },

    watch: {
      async showaddform(bool) {
        if (bool) {
          await this.$nextTick();
          //need to remove all class so input is adapted to 100% width
          for (let i = 0; i < this.$refs.add_bookmark_input.$el.children.length; i++) {
            this.$refs.add_bookmark_input.$el.children[i].classList.remove('col-sm-12')
          }
        }
      }
    },

    created() {
      this.$on('close', () => this.showaddform = false);
    },

  };

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"treeview-menu g3w-spatial-bookmarks menu-items",class:{'g3w-tools': !_vm.showaddform},attrs:{"id":"g3w-spatial-bookmarks"}},[(_vm.showaddform)?_c('li',[_c('div',{staticStyle:{"display":"flex","justify-content":"end"}},[_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left",value:('close'),expression:"'close'",arg:"left"}],staticClass:"sidebar-button sidebar-button-icon",class:_vm.$fa('close'),staticStyle:{"padding":"5px","margin":"3px"},on:{"click":function($event){$event.stopPropagation();_vm.showaddform = false}}})]),_vm._v(" "),_c('div',{staticStyle:{"color":"#FFF","text-align":"justify","position":"relative","border-radius":"3px","margin":"5px 2px 5px 2px","white-space":"pre-line","background-color":"#384246 !important"}},[_c('span',{staticStyle:{"text-align":"center","font-size":"0.7em","margin-top":"-4px","margin-left":"-4px","background-color":"var(--bgcolor)","font-weight":"bold","color":"#fff","position":"absolute","top":"0","left":"0","width":"15px","height":"15px","border":"1px solid #fff","border-radius":"50%"}},[_vm._v("i")]),_vm._v(" "),_c('div',{directives:[{name:"t",rawName:"v-t",value:('Move on map extent, insert name and click Add'),expression:"'Move on map extent, insert name and click Add'"}],staticStyle:{"max-height":"200px","padding":"10px","overflow-y":"auto"}})]),_vm._v(" "),_c('div',{staticClass:"container add-bookmark-input",staticStyle:{"padding":"5px","width":"100%"}},[_c('input-text',{ref:"add_bookmark_input",attrs:{"state":_vm.addbookmarkinput}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"5px"}},[_c('button',{directives:[{name:"t",rawName:"v-t",value:('add'),expression:"'add'"},{name:"disabled",rawName:"v-disabled",value:(!_vm.addbookmarkinput.validate.valid),expression:"!addbookmarkinput.validate.valid"}],staticClass:"sidebar-button-run btn btn-block",on:{"click":function($event){$event.stopPropagation();return _vm.addBookMark.apply(null, arguments)}}})])]):[(_vm.is_staff)?_c('div',{staticClass:"content-bookmarks"},[_c('span',{directives:[{name:"t",rawName:"v-t",value:('Project Bookmarks'),expression:"'Project Bookmarks'"}],attrs:{"hidden":_vm.is_mobile}}),_vm._v(" "),_c('a',{staticStyle:{"float":"right"},attrs:{"hidden":_vm.is_mobile,"href":("https://docs.qgis.org/3.34/" + _vm.lang + "/docs/user_manual/map_views/map_view.html#bookmarking-extents-on-the-map"),"target":"_blank","data-i18n-title":"QGIS Docs","data-placement":"right"}},[_c('i',{class:_vm.$fa('external-link')})])]):_vm._e(),_vm._v(" "),_vm._l((_vm.project.bookmarks),function(bookmark){return [(bookmark.nodes)?_c('li',[_c('div',{staticStyle:{"font-weight":"bold","width":"100%"},style:({ borderBottom: bookmark.expanded ? '2px solid #2c3b41' : 'none' }),on:{"click":function($event){$event.stopPropagation();bookmark.expanded = !bookmark.expanded}}},[_c('span',{class:_vm.$fa(bookmark.expanded ? 'caret-down' : 'caret-right'),staticStyle:{"margin-right":"5px"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(bookmark.name))])]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(bookmark.expanded),expression:"bookmark.expanded"}],staticStyle:{"margin-left":"10px"}},_vm._l((bookmark.nodes),function(node){return _c('li',{staticClass:"spatial-bookmark",on:{"click":function($event){$event.stopPropagation();return _vm.gotoSpatialBookmark(node)}}},[_c('div',[_c('span',{class:_vm.$fa('bookmark'),staticStyle:{"margin-right":"5px","font-size":"0.7em"}}),_vm._v(" "),_c('span',{staticClass:"g3w-long-text"},[_vm._v(_vm._s(node.name))])])])}),0)]):_c('li',{staticClass:"spatial-bookmark",on:{"click":function($event){$event.stopPropagation();return _vm.gotoSpatialBookmark(bookmark)}}},[_c('div',[_c('span',{class:_vm.$fa('bookmark'),staticStyle:{"margin-right":"5px","font-size":"0.7em"}}),_vm._v(" "),_c('span',{staticClass:"g3w-long-text"},[_vm._v(_vm._s(bookmark.name))])])])]}),_vm._v(" "),_c('div',{staticClass:"content-bookmarks",staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center","margin-top":"10px"}},[_c('span',{directives:[{name:"t",rawName:"v-t",value:('User Bookmarks'),expression:"'User Bookmarks'"}],attrs:{"hidden":_vm.is_mobile}}),_vm._v(" "),_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left",value:('add'),expression:"'add'",arg:"left"}],staticClass:"sidebar-button sidebar-button-icon",class:_vm.$fa('plus'),staticStyle:{"padding":"5px","cursor":"pointer"},attrs:{"hidden":_vm.is_mobile},on:{"click":function($event){$event.stopPropagation();return _vm.showAddForm.apply(null, arguments)}}})]),_vm._v(" "),_vm._l((_vm.user.bookmarks),function(bookmark){return _c('li',{staticClass:"spatial-bookmark",on:{"click":function($event){$event.stopPropagation();return _vm.gotoSpatialBookmark(bookmark)}}},[_c('div',[_c('span',{class:_vm.$fa('bookmark'),staticStyle:{"margin-right":"5px","font-size":"0.7em"}}),_vm._v(" "),_c('span',{staticClass:"g3w-long-text"},[_vm._v(_vm._s(bookmark.name))])]),_vm._v(" "),_c('span',{staticClass:"sidebar-button sidebar-button-icon",staticStyle:{"color":"red","margin":"5px","cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();return _vm.removeBookMark(bookmark.id)}}},[_c('i',{class:_vm.$fa('trash')})])])})]],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-0187c0e1_0", { source: ".content-bookmarks{font-weight:700;color:#fff;padding:5px;border-bottom:1px solid #fff;margin-bottom:2px}.spatial-bookmark{display:flex;align-items:baseline;justify-content:space-between;padding:5px!important}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "SpatialBookMarks.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__